import React, { useContext, useEffect, useState } from "react";
import {Form, Row, Col, Button, Card } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";

const AddProduct = () => {
  const { id } = useParams();
  const location = useLocation();
  const { row } = location.state || {};
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = {
    "auth-token": authToken,
    authorization: accessToken,
  };
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    productName: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };


  useEffect(() => {
    if (id) {
      if (row) {
        setFormData({
          productName: row?.name,
          description: row?.description,
        });
      }
    }
  }, [id, row]);
  


  const validate = () => {
    const newErrors = {};

    if (!formData.productName) {
      newErrors.productName = "Product Name is required.";
    }
    if (!formData.description) {
      newErrors.description = "Description is required.";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});

    const { productName ,description } = formData;
    let updatedFormData = {
        "name" : productName,
        "description" : description
    };

    const formDataToSubmit = new FormData();
    Object.keys(updatedFormData).forEach((key) => {
      formDataToSubmit.append(key, updatedFormData[key]);
    });

    try {
      if (id) {
        const formData1 = { ...updatedFormData };
        formData1.id = id;
        const res = await APIServices.post(
          `/admin/product/update`,
          formData1,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");
          setTimeout(() => {
            navigate("/admin/products");
          }, 2000);
        } else if (res?.status === 401) {
          logout();
          navigate("/");
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      } else {
        const res = await APIServices.post(
          "/admin/product/add",
          updatedFormData,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");
          setTimeout(() => {
            navigate("/admin/products");
          }, 2000);
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      }
    } catch (error) {
      console.error("API call error:", error);
      showToast("An unexpected error occurred. Please try again.", "error");
    }
  };

  
  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };
  return (
    <>
      <div className="addmom_inner">
        <div className="addmom_header d-flex justify-content-start mb-3">
          <h1 className="font_blue_18 font-600">{id ? "Update Products" : "Add Products"}</h1>
        </div>

        <Card className="mom_form">
          <Card.Body>
            <Form className="">
              <Row>
                <Col md={12} lg={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Product Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="productName"
                      placeholder="Enter Product Name"
                      value={formData.productName}
                      onChange={handleChange}
                    />
                    {errors.productName && (
                      <div className="text-danger">{errors.productName}</div>
                    )}
                  </Form.Group>
                </Col>
              

                <Col md={12} lg={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Description
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="description"
                      placeholder="Write here..."
                      value={formData.description}
                      onChange={handleChange}
                      style={{ height: "120px" }}
                    />
                    {errors.description && (
                      <div className="text-danger">{errors.description}</div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-end gap-2">
                <Button
                  className="btn blue_border"
                  onClick={() => navigate("/admin/products")}
                >
                  Cancel
                </Button>
                <Button className="btn red_button" onClick={handleSubmit}>
                  Save
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>

    
      <ToastContainer />
    </>
  );
};

export default AddProduct;
